import { Button, Grid, Typography, Box, Hidden, FormControl, InputLabel, Select } from "@mui/material";
import { Search as IconSearch, PersonAdd as IconPersonAdd } from "@mui/icons-material";
import * as puntuacionService from "../../services/puntuacionService";
import * as catalogoService from "../../services/catalogoService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setValue, setListTipos, setListClases, setListEstados } from '../../redux/puntuacionSearchSlice';
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";

// Navegabilidad de las escalas de puntuacion.
const Index = () => {
    const { isReadOnly } = useMantenimiento("puntuacion");
    const filters = useSelector((state) => state.puntuacionSearch.filters);
    const listTipos = useSelector((state) => state.puntuacionSearch.listTipos);
    const listClases = useSelector((state) => state.puntuacionSearch.listClases);
    const listEstados = useSelector((state) => state.puntuacionSearch.listEstados);

    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchResults = async () => {
        setCargando(true);

        const data = await puntuacionService.getsPuntuacionView()
            .then((data) => {
                setCargando(false);
                return data || [];
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
                return [];
            });

        let lista = data;

        if (filters.idTipo != null && parseInt(filters.idTipo) > 0) {
            lista = lista.filter((row) => row.idTipo == filters.idTipo);
        }

        // Clase: separa las escalas de sesion de las de planificacion.
        if (filters.idClase != null && parseInt(filters.idClase) > 0) {
            lista = lista.filter((row) => row.idClase == filters.idClase);
        }

        if (filters.idEstado != null && parseInt(filters.idEstado) > 0) {
            lista = lista.filter((row) => row.idEstado == filters.idEstado);
        }

        setResults(lista);
    }
    const fetchTipos = async () => {
        await catalogoService.getCatalogosByPadre(62)
            .then((data) => {
                dispatch(setListTipos(data));
            })
            .catch((err) => {
                console.log("Err: ", err)
            });
    }
    const fetchClases = async () => {
        // Catalogo 320: Clases de puntuacion (sesiones / planificacion).
        await catalogoService.getCatalogosByPadre(320)
            .then((data) => {
                dispatch(setListClases(data));
            })
            .catch((err) => {
                console.log("Err: ", err)
            });
    }
    const fetchEstados = async () => {
        await catalogoService.getCatalogosByPadre(1)
            .then((data) => {
                dispatch(setListEstados(data));
            })
            .catch((err) => {
                console.log("Err: ", err)
            });
    }

    useEffect(() => {
        fetchTipos();
        fetchClases();
        fetchEstados();
        fetchResults();
    }, []);

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'codigo', headerName: 'Codigo', width: 100, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/puntuacion/edit/' + cellValues.row.id} style={{ color: 'inherit' }}>{cellValues.row.codigo}</Link>;
            }
        },
        { field: 'nombre', headerName: 'Nombre', width: 260, sortable: false, headerAlign: 'left' },
        { field: 'tipo', headerName: 'Tipo', width: 120, sortable: false, headerAlign: 'center' },
        { field: 'clase', headerName: 'Clase', width: 160, sortable: false, headerAlign: 'center' },
        { field: 'valorMinimo', headerName: 'Min', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'valorMaximo', headerName: 'Max', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'cantidadDetalles', headerName: 'Valores', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'cantidadGrupos', headerName: 'Grupos', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'estado', headerName: 'Estado', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Puntuaciones
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-tipo" shrink>Tipo</InputLabel>
                                    <Select
                                        native
                                        label="Tipo"
                                        value={filters.idTipo}
                                        onChange={(event) => {
                                            dispatch(setValue({ name: "idTipo", value: event.target.value }))
                                        }}
                                        inputProps={{
                                            name: 'idTipo',
                                            id: 'input-tipo',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listTipos.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-clase" shrink>Clase</InputLabel>
                                    <Select
                                        native
                                        label="Clase"
                                        value={filters.idClase}
                                        onChange={(event) => {
                                            dispatch(setValue({ name: "idClase", value: event.target.value }))
                                        }}
                                        inputProps={{
                                            name: 'idClase',
                                            id: 'input-clase',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todas)"}</option>
                                        {listClases.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estado" shrink>Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.idEstado}
                                        onChange={(event) => {
                                            dispatch(setValue({ name: "idEstado", value: event.target.value }))
                                        }}
                                        inputProps={{
                                            name: 'idEstado',
                                            id: 'input-estado',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstados.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" fullWidth size="medium" onClick={() => {
                                    fetchResults()
                                }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                disabled={isReadOnly}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        icon: <IconPersonAdd />,
                                        disabled: isReadOnly,
                                        onClick: () => navigate("/puntuacion/edit/0")
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index